import React from 'react';

const FinancialPlanningDisabilityBottomline = () => {
  const benefits = [
    {
      title: "Income Protection Framework",
      description: "Implementing a customized mix of short and long-term disability insurance with appropriate elimination periods and benefit structures ensures continuous income regardless of work capacity."
    },
    {
      title: "Modified Expense Planning",
      description: "Creating detailed projections of disability-related expenses alongside reduced discretionary spending provides a realistic financial roadmap that addresses both medical and lifestyle adaptations."
    },
    {
      title: "Accessible Asset Structure",
      description: "Strategically organizing assets and savings in easily manageable, accessible accounts with proper authorization mechanisms ensures financial resources remain available despite physical limitations."
    },
    {
      title: "Government Benefit Optimization",
      description: "Navigating and coordinating various disability assistance programs alongside private resources maximizes total benefits while avoiding disqualification from essential support services."
    }
  ];

  return (
    <div className="w-full bg-gradient-to-br from-[#113262] to-[#1C52A0] py-12 px-8">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="text-center mb-16">
          <h2 className="text-white text-2xl md:text-3xl lg:text-4xl font-bold mb-4">
            Bottomline: Benefits of Strategic Disability Financial Planning
          </h2>
          <div className="w-24 h-1 bg-[#F49611] mx-auto mt-4"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
          {benefits.map((benefit, index) => (
            <div key={index} className="relative">
              {/* Decorative number */}
              <div className="absolute -left-8 top-0 text-6xl font-bold text-white opacity-30">
                {index + 1}
              </div>
              
              {/* Content */}
              <div className="relative">
                <div className="flex items-start space-x-4">
                  {/* Vertical line decoration */}
                  <div className="hidden md:block w-1 h-full bg-gradient-to-b from-[#F49611] to-transparent"></div>
                  
                  <div className="flex-1">
                    <h3 className="text-[#F49611] text-xl font-semibold mb-4">
                      {benefit.title}
                    </h3>
                    <p className="text-white/80 text-base leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FinancialPlanningDisabilityBottomline;